export const BenchmarkSection = ({ name = '', colour = 'white' }) => (
  <tr className={`bg-${colour}`}>
    <th className={`bg-${colour}`} colSpan={8}>{name}</th>
  </tr>
);
